import { InfoNotification, WarningNotification } from '@ardoq/status-ui';
import { NotificationData } from './types';

type TabNotificationProps = {
  notificationData?: NotificationData;
};

export const TabNotification = ({ notificationData }: TabNotificationProps) => {
  if (!notificationData) {
    return null;
  }

  const { message, type } = notificationData;
  const Notification = type === 'info' ? InfoNotification : WarningNotification;

  return (
    <Notification alignItems="center" data-testid="groupTabNotification">
      {message}
    </Notification>
  );
};
